import o from "./_getNative.js";
import r from "./_root.js";
var t = o(r, "Promise");
const i = t;
export {
  i as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_Promise.js
// module id = 1454
// module chunks = 67